/**
 * W66.W6 — Header strip: account name, descriptor, posture badge,
 * score placeholder, "What this account demonstrates" call-out.
 */

import React from "react";
import PosturePill from "./PosturePill";

interface HeaderStripProps {
  accountName: string;
  planData: Record<string, any>;
}

export default function HeaderStrip({ accountName, planData }: HeaderStripProps) {
  const header = planData.header ?? {};
  const descriptor = header.descriptor ?? "";
  const posture = header.posture ?? null;
  const score = header.score ?? 0;
  const demonstrates = header.demonstrates ?? "";

  return (
    <div style={{ marginBottom: 24 }}>
      {/* Title row */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 16,
          marginBottom: 4,
        }}
      >
        <h1
          style={{
            fontSize: 28,
            fontWeight: 800,
            color: "#111827",
            margin: 0,
            lineHeight: 1.1,
          }}
        >
          {accountName}
        </h1>

        <div style={{ display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 10, color: "#6B7280", fontWeight: 600, marginBottom: 2 }}>
              AIP POSTURE
            </div>
            <PosturePill posture={posture} />
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 10, color: "#6B7280", fontWeight: 600, marginBottom: 2 }}>
              SCORE
            </div>
            <div
              style={{
                fontSize: 16,
                fontWeight: 700,
                color: score > 0 ? "#111827" : "#9CA3AF",
              }}
            >
              {score > 0 ? `${score}/100` : "\u2014\u00a0/\u00a0100"}
            </div>
          </div>
        </div>
      </div>

      {/* Descriptor */}
      {descriptor && (
        <p style={{ fontSize: 13, color: "#374151", margin: "0 0 12px", fontStyle: "italic" }}>
          {descriptor}
        </p>
      )}

      {/* Demonstrates call-out */}
      {demonstrates && (
        <div
          style={{
            background: "rgba(220,38,38,0.08)",
            border: "1px solid rgba(220,38,38,0.2)",
            borderLeft: "3px solid #DC2626",
            borderRadius: 6,
            padding: "10px 14px",
            marginTop: 8,
          }}
        >
          <span
            style={{
              fontSize: 11,
              fontWeight: 700,
              color: "#DC2626",
              textTransform: "uppercase",
              letterSpacing: "0.06em",
            }}
          >
            What this account demonstrates
          </span>
          <p style={{ margin: "4px 0 0", fontSize: 13, color: "#111827", lineHeight: 1.5 }}>
            {demonstrates}
          </p>
        </div>
      )}
    </div>
  );
}
